module.exports = __webpack_public_path__ + "img/circle_trash_recover.1cb5b818.png";